import React from 'react'
import MDBox from 'components/MDBox'

export default function elementoContenitorePreLogin(props) {
    var sx = Object.assign({ width: '100%',  boxSizing: 'border-box' }, props.boxProps)
    return <MDBox  mx='auto' display='flex' flexDirection='column' component='section' pt={15} pb={12} pl={3} pr={3} sx={sx}>{props.children}</MDBox>
}
